import { PrintCardMenu } from './print-card-menu';
import { LocationPriceStream } from '../../enum/shared/location-price-stream';
import type { SectionWithProducts } from '../section/section-with-products';
import type { SectionRowViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-row-view-models/SectionRowViewModel';
import type { SectionColumnViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/SectionColumnViewModel';
import { SpecificPriceWithoutDiscounts } from '../../enum/shared/specific-price-without-discounts.enum';
import { FONT, FontStyleSheet } from '../font-style-sheets';

export class SessionsPrintCardMenu extends PrintCardMenu {
  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [
      FONT.Poppins.Medium_500,
      FONT.Poppins.SemiBold_600,
      FONT.Nunito.Bold_700,
      FONT.NunitoSans.Regular_400,
      FONT.NunitoSans.Medium_500,
      FONT.NunitoSans.Bold_700,
      FONT.NunitoSans.ExtraBold_800,
      FONT.NunitoSans.Black_900
    ];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/lol7ube.css';
  }

  getPriceDecimal(
    priceStream: LocationPriceStream,
    locationId: number,
    s: SectionWithProducts,
    rowVM: SectionRowViewModel,
    colVm: SectionColumnViewModel
  ): string {
    const priceDecimal = super.getPriceDecimal(priceStream, locationId, s, rowVM, colVm);
    if (priceStream !== LocationPriceStream.Default) {
      return priceDecimal.replace('.', '');
    }
    return priceDecimal;
  }

  getOriginalPriceDecimal(
    priceStream: LocationPriceStream,
    locationId: number,
    sectionWithProducts: SectionWithProducts,
    sectionRowViewModel: SectionRowViewModel,
    sectionColumnViewModel: SectionColumnViewModel,
    specificPriceWithoutDiscounts: SpecificPriceWithoutDiscounts[]
  ): string {
    const originalPriceDecimal = super.getOriginalPriceDecimal(
      priceStream,
      locationId,
      sectionWithProducts,
      sectionRowViewModel,
      sectionColumnViewModel,
      specificPriceWithoutDiscounts
    );
    if (priceStream !== LocationPriceStream.Default) {
      return originalPriceDecimal.replace('.', '');
    }
    return originalPriceDecimal;
  }

  shouldStandardizeDominantStrainType(): boolean {
    return false;
  }
}
